import React, { useRef } from "react";
import { formatAppDate, DEFAULT_DATE_FORMAT } from "../utils/dateUtils.js";

/**
 * Date picked from a calendar instead of typed: shows the date in the app's format (e.g. 01-09-2026)
 * and opens the browser's calendar on tap. value / onChange use YYYY-MM-DD.
 */
export function DateField({ value, onChange, min, max, label, dateFormat = DEFAULT_DATE_FORMAT, style }) {
  const inputRef = useRef(null);

  const open = () => {
    const input = inputRef.current;
    if (!input) return;
    try {
      if (typeof input.showPicker === "function") {
        input.showPicker();
        return;
      }
    } catch (_) {
      // showPicker can refuse (e.g. not from a user gesture) — fall back to focusing the input
    }
    input.focus();
    input.click();
  };

  return (
    <div style={{ position: "relative", flex: 1, minWidth: 0, ...style }}>
      {label && <div style={{ fontSize: "0.7rem", color: "var(--text-dim)", marginBottom: 2 }}>{label}</div>}
      <button
        type="button"
        className="form-control"
        onClick={open}
        aria-label={label ? `${label}: ${value ? formatAppDate(value, dateFormat) : "pick a date"}` : "Pick a date"}
        style={{ display: "flex", alignItems: "center", gap: "0.4rem", width: "100%", textAlign: "left", cursor: "pointer" }}
      >
        <span aria-hidden="true">📅</span>
        <span style={{ color: value ? "var(--text-main)" : "var(--text-dim)" }}>{value ? formatAppDate(value, dateFormat) : "Pick a date"}</span>
      </button>
      {/* The real input sits under the button so the native calendar opens in the right place */}
      <input
        ref={inputRef}
        type="date"
        value={value || ""}
        min={min || undefined}
        max={max || undefined}
        onChange={(e) => e.target.value && onChange(e.target.value)}
        tabIndex={-1}
        aria-hidden="true"
        style={{ position: "absolute", left: 0, bottom: 0, width: "100%", height: 1, opacity: 0, pointerEvents: "none", border: 0, padding: 0 }}
      />
    </div>
  );
}

export default DateField;
